// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HAi7","icon":"styles_icon__yg1ph"};